export const apiBaseURL = process.env.NODE_ENV === 'production' ? "/new_api" : "";

export const APP_ID = 1; // web: 1  app: 2

export const apis = {
    // project
    appProject: '/project',
    addProjectUser: '/project/{projectId}/user',
    getProject: '/project/{projectId}',
    updateProject: '/project/{projectId}',
    deleteProject: '/project/{projectId}',
    stopProject: '/project/{projectId}/stop',
    searchProject: '/project/search',
    lookupAllProject: '/project/typeAhead',
    uploadFile: '/project/{projectId}/file',
    updateFile: '/project/{projectId}/file/{fileId}',
    getFile: '/project/{projectId}/file/{fileId}',
    getImage: '/images/{filename}',
    updateProjectGateway: "/project/gateway/change",

    // auth
    login: "/auth/login",
    logout: "/auth/logout",

    // gateway
    getGateway: "/gateway/{datewayId}",
    getGatewayDevices: "/gateway/{datewayId}/listDevices",
    createGateway: "/gateway",
    updateGateway: "/gateway/{gatewayId}",
    deleteGateway: "/gateway/{gatewayId}",
    searchGateway: "/gateway/search",

    // device
    batchImportDevices: "/project/{projectId}/device/batchImport",
    batchImportGLobalDevices: "/device/excel/import",
    globalDevicesTemplate: "/device/4g/template",
    batchAddDevices: "/project/{projectId}/device/batchAdd",
    updateDevice: "/project/{projectId}/device/{deviceSn}",
    batchDeleteDevices: "/project/{projectId}/device/batchDelete",
    searchDevice: "/project/{projectId}/device/search",
    getDevice: "/project/{projectId}/device/{deviceSn}",
    getDeviceDetails: "/device/sn/{deviceSn}",
    toggleSwitches: "/device/command",
    deviceDownload: "/project/{projectId}/device/download",

    // global list
    globalDeviceSearch: "/device/search",
    globalDeviceUpdate: "/device/{devSn}",
    globalDeviceGet: "/device/{devSn}",
    globalDeviceCreate: "/device",
    globalDeviceBatchDelete: "/device/batchDelete",
    globalDeviceBatchImport: "/device/excel/import",
    deviceTransfer: "/project/device/gateway/change",

    // template download
    downloadDeviceListTempalte: "/project/device/importTemplate/download",

    // online datas
    getAlarms: "/project/device/online/alarm",
    getRealtimeDatas: "/project/device/online/realtime",

    // history datas
    getHistoryLogs: "/history/device/realtime",
    getHistoryAlarms: "/history/device/alarm",
    realtimeDownload: "/history/device/realtime/download",
    alarmDownload: "/history/device/alarm/download",
    getAlarmTypes: "/ref/alarmTypes",
    searchHistoryProjects: "/history/project/search",
    searchHistoryProjectDevices: "/history/project/{projectId}/device/search",
    getDefaultProject: "/project/default",
    
    // users
    setUserRoles: "/user/roles",
    searchUsers: "/user/search",
    searchUsersGlobal: "/user/pagedList",
    updateUser: "/user/{userId}",
    getUser: "/user/{userId}",
    deleteUser: "/user/{userId}",
    addUser: "/user",
    resetPassword: "/user/{userId}/resetPassword",
    updatePassword: "/user/password/update",
    roleList: "/role/list",

    // organization
    searchOrgs: "/organization/search",
    getOrg: "/organization/{orgnizationId}",
    updateOrg: "/organization/{orgnizationId}",
    createOrg: "/organization",
    deleteOrg: "/organization/{orgnizationId}",

    // task
    searchTask: "/task/search",
    closeTask: "/task/complete",
    completeTask: "/task/complete",
    assignTask: "/task/assign",

    // crom jobs
    searchJobs: "/scheduler/jobs",
    rescheduleJobs: "/scheduler/jobs/reschedule",

    // system logs
    getMetadata: "/userOperationLog/meta",
    queryOperationLog: "/userOperationLog/queryByPage",

    // dashboard
    getOrgAlarms: "/report/alarm/{orgId}",
    getProjectAlarms: "/report/alarm/project/{projectId}",
    getOrgAlarmTypes: "/report/alarmType/{orgId}",
    getProjectAlarmTypes: "/report/alarmType/project/{projectId}",
    getOrgReport: "/report/projects/{orgId}",
    getOrgReportV2Summary: "/report/v2/projects/{orgId}",
    getProjectReportV2: "/report/v2/project/{projectId}",
    getOrgRealtimeData: "/report/realtime/{orgId}",
    getProjectRealtimeData: "/report/realtime/project/{projectId}",
    getOrgRealtimeOnlineRatio: "/report/realtime/onlineRatio/org/{orgId}/{frequency}",
    getProjectRealtimeOnlineRatio: "/report/realtime/onlineRatio/project/{projectId}/{frequency}",

}

export const alarmTypes = [
    {label: '过载报警', value: 'ol_alarm'},
    {label: 'N相温度报警', value: 'N_temp_alarm'},
    {label: '通讯中断', value: 'comm_interrupt'},
]

export const ACCESS_TOKEN_KEY = 'ACCESS_TOKEN'
export const USER_ID_KEY = 'USER_ID'
export enum TaskStatus {
    INITIAL = 'INITIAL',
    ACCEPT = 'ACK',
    COMPLETED = 'COMPLETED',
    CLOSED = 'CLOSED',
}
export enum TaskType {
    DEVICE_ALARM = 'DEVICE_ALARM',
    GATEWAY_ALARM = 'GATEWAY_ALARM',
}


export const TaskStatusOptions = [
    {
        value: TaskStatus.INITIAL,
        label: '待处理'
    },
    {
        value: TaskStatus.ACCEPT,
        label: '已认领'
    },
    {
        value: TaskStatus.COMPLETED,
        label: '处理完成'
    },
    {
        value: TaskStatus.CLOSED,
        label: '已关闭'
    },
];


export const TaskTypeOptions = [
    {
        value: TaskType.DEVICE_ALARM,
        label: '设备告警'
    },
    {
        value: TaskType.GATEWAY_ALARM,
        label: '网关告警'
    },
]

export const DEVICE_SN_PREFIX = 'QY2024010100';

export const NAV_HEIGHT = 64;
export const BREAD_CRUMB_HEIGHT = 54;
export const BODY_PADDING_HORIZON = 48;
export const BODY_PADDING_VERTICAL = 0;
export const CONTNET_PADDING = 24;
export const FOOTER_HEIGHT = 48;
export const CONTAINER_HEIGHT = document.documentElement.clientHeight - NAV_HEIGHT - BREAD_CRUMB_HEIGHT - CONTNET_PADDING * 2 - BODY_PADDING_VERTICAL * 2;
export const CONTENT_HEIGHT = CONTAINER_HEIGHT - CONTNET_PADDING * 2;
export const CONTENT_WIDTH = document.documentElement.clientWidth - CONTNET_PADDING * 2 - BODY_PADDING_HORIZON * 2;


export const PROJECT_IS_INTERSECTING = 'ProjectIsIntersecting'

export const ROLES = {
    ELECTRICIAN: 'ELECTRICIAN',
    OBSERVER: 'OBSERVER',
    MANAGER: 'MANAGER',
    REGIONAL_HEADER: 'REGIONAL_HEADER',
    ADMIN: 'ADMIN',
}
export const deviceDefaultValues = {
    type: '5G',
    switchCount: 1,
    isControlled: true,
    electricalBoxCapacity: 15,
    deviceSn: '',
    isKeepOnline: false,
	isPowerSupply: false
}
